import React from 'react';
import { useDropzone } from 'react-dropzone';

export function useFileUploader({ fileKey, multiple, onChange, ...rest }) {
  const [fileNames, setFileName] = React.useState<string[]>([]);

  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) return;
      const file = acceptedFiles[0];
      setFileName(prevState => {
        if (multiple) {
          return [...prevState, file.name];
        }
        return [file.name];
      });
      const data = new FormData();
      data.append(fileKey, file);
      data.append('fileName', file.name);
      onChange(data, fileNames);
    },
    [fileKey, fileNames, multiple, onChange]
  );

  const dropzoneProps = useDropzone({ onDrop, multiple, ...rest });

  return { ...dropzoneProps, fileNames };
}
